import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/store-vercel/src/app/ui/accounts/forgot-password-form.tsx");
